export enum CheckoutButtonMethodType {
    BRAINTREE_PAYPAL = 'braintreepaypal',
    BRAINTREE_PAYPAL_CREDIT = 'braintreepaypalcredit',
    GOOGLEPAY_BRAINTREE = 'googlepaybraintree',
    MASTERPASS = 'masterpass',

}
